<app-menu></app-menu>
/
<div class="appContentsContainer">
  <form (ngSubmit)="onSave()" class="formGroup container halfForm">
    <div class="pageTitle mb-0">
      {{ "mailBoxRules.title" | translate }}
    </div>
    <div class="lineGradient"></div>
    <div class="pageTitle">Paso 1- Seleccione el analista</div>

    <div class="row shortRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label>Analista</label>
          </div>
        </div>
        <div class="inputContainer">
          <app-input-selector-with-search
            *ngIf="analistasList.length > 0"
            [list]="analistasList"
            [fields]="['usuarioId']"
            [id]="'usuarioId'"
            (sendValue)="valueSelector($event)"
          ></app-input-selector-with-search>
        </div>
      </div>
      <div *ngIf="analystSelected != ''">
        <div class="pageTitle">
          Paso 2 - Asigne las marcas al analista seleccionado
        </div>
        <div class="lineGradient"></div>
        <div
          class="float-left ml-4"
          *ngFor="let brand of brandsList; let i = index"
        >
          <input
            class="checkbox"
            type="checkbox"
            style="cursor: pointer !important"
            [checked]="brand.checked"
            (click)="selectItem(brand)"
          />
          <label class="ml-2">{{ brand.maId }}</label>
        </div>
        <div class="float-left ml-4">
          <input
            class="checkbox"
            type="checkbox"
            style="cursor: pointer !important"
            [checked]="allBrandsSelected"
            (click)="selectAllBrands()"
          /><label class="ml-2">Selecciona todos</label>
        </div>
      </div>
      <div *ngIf="analystSelected != ''">
        <div class="pageTitle">
          Paso 3 - Asigne los certificados al analista seleccionado
        </div>
        <div class="lineGradient"></div>
        <div class="containerCertificates">
          <input
            class="checkbox"
            type="checkbox"
            style="cursor: pointer !important"
            [checked]="allCertificatesSelected"
            (click)="selectAllCertificate()"
          /><label class="ml-2">Selecciona todos</label>
          <div
            [ngClass]="isPar(i) ? 'element' : 'element2'"
            *ngFor="let certificate of certificatesList; let i = index"
          >
            <div>
              <input
                type="checkbox"
                style="cursor: pointer !important"
                [checked]="certificate.checked"
                (click)="selectItem(certificate)"
              />

              <label class="marginLabels"
                >{{ certificate.tipoCertificado }} -
                {{ certificate.tipoReforma }} -
                {{ certificate.descripcion }}</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="buttonsGroup">
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          *ngIf="!edited"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
        <button
          class="formButtonBack"
          type="button"
          *ngIf="edited"
          [swal]="confirmSwal"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
      <div class="okButton">
        <div class="centerButton">
          <button class="formButtonOk" type="submit">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>

    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goPredefinedMailBox()"
    >
    </swal>
  </form>
</div>
